import axios from 'axios'
import { baseURL, challengeURL, } from '@/constants/api'
import qs from 'qs'
import moment from 'moment/moment'
import { captureException, } from '@sentry/browser'
import { EventBus, } from '@/event-bus'
import apiExplorer from '@/api_explorer'
import { getPropValue, } from '../utils/getPropValue'
import store from '@/store'

export const authClient = axios.create({
  baseURL: challengeURL,
  withCredentials: true, // required to handle the CSRF token
})

/*
 * Add a response interceptor
 */
authClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      [ 401, 419, ].includes(error.response.status) &&
      store.getters['auth/authUser']
    ) {
      store.dispatch('auth/logout')
    }
    return Promise.reject(error)
  }
)

export const getData = ({ state, }, { endpoint = 'lei-records', params = {}, cb, cbCatch, baseUrl = baseURL, }) => {
  return axios.get(createQueryUrl(baseUrl, endpoint, params), {})
    .then(({ data, }) => {
      apiExplorer(data, endpoint)
      if (cb) cb(data)
      return data
    })
    .catch((error) => {
      captureException(error)
      cbCatch ? cbCatch(error) : console.error(error)
    })
}

export const getAuthenticatedUser = async () => {
  return await authClient.get('/users/auth')
}

export const getAuthUser = async ({ commit, }) => {
  commit('SET_LOADING', true)
  try {
    const response = await getAuthenticatedUser()
    commit('SET_USER', response)
    commit('SET_LOADING', false)
    return response
  } catch (error) {
    commit('SET_LOADING', false)
    commit('SET_USER', null)
  }
}

export const postData = async ({ endpoint, apiV = '', data, headers, }) => {
  await authClient.get('/sanctum/csrf-cookie')
  return await authClient.post(challengeURL + apiV + endpoint, data, { headers, })
    .catch((error) => {
      captureException(error)

      if ([
        400,
        401,
        403,
        404,
        405,
        422,
        429,
      ].includes(error.response.status)) {

        // We display all error messages
        EventBus.$emit('post-data-error', {
          title: error.response.statusText,
          message: error.response.data.errors.map((e) => '- ' + e.detail).join('<br/>'),
        })
      } else {
        // Anything else
        EventBus.$emit('post-data-error', {
          title: 'Error',
          message: 'Challenge request failed with message [' + error.response.statusText + ']. Please contact GLEIF.',
        })
      }

      return Promise.reject(error)
    })
}

export const createQueryUrl = (baseUrl, endpoint, params) => {
  return `${baseUrl}${endpoint}${qs.stringify(params, {
    skipNulls: true,
    addQueryPrefix: true,
  })}`
}

export const timeFormat = (time) => time
  ? moment(time).format('YYYY-MM-DD HH:mm:ssZ')
  : null

export const shortTimeFormat = (time) => time
  ? moment(time, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')
  : null

export const shortDateFormat = (time) => time
  ? moment(time, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')
  : null

export const timeFormatRevert = (time) => time
  ? moment(time, 'YYYY-MM-DD HH:mm:ssZ').toISOString()
  : null
export const parseDate = (date, format) => date && format ? moment(date).format(format) : null
export const timeToISOString = (date) => date ? moment(date).toISOString() : null

export const createDownloadLink = (url) => {
  const fileLink = document.createElement('a')
  fileLink.href = url
  fileLink.click()
}



// WEBPACK FOOTER //
// ./src/store/helpers.js